import { TableColumn } from "./dataInterface";

export const outsideEntryFormTableColumn: TableColumn = {
  title: "外部ETフォーム一覧",
  detail: true,
  detailTitle: "外部ETフォーム詳細",
  detailColumn: "詳細",
  detailKey: ["id"],
  addTitle: "外部ETフォーム登録",
  editAuth: ["マスターアカウント", "スタッフアカウント"],
  tableFunction: [
    {
      name: "削除",
      width: "40px",
      auth: ["マスターアカウント", "スタッフアカウント"],
    },
  ],
  postCSVTitle: "",
  dataColumn: [
    {
      key: "entry_form_edit_flg",
      name: "質問追加・削除",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: true,
      tableMinWidth: "140px",
      sort: false,
      tableValue: "edit_check",
      serch: false,
      serchType: null,
      detail: false,
      edit: false,
      editId: "id",
      editType: null,
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "high_rank_company_name",
      name: "上位店名",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: true,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "high_rank_company",
      detail: true,
      edit: false,
      editId: "high_rank_company_id",
      editType: null,
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "high_rank_company_id",
      name: "上位店名",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: false,
      tableMinWidth: "",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: false,
      edit: false,
      editId: "id",
      editType: null,
      add: true,
      addType: "high_rank_company",
      addMessage: "",
    },
    {
      key: "product_name",
      name: "商材名",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: true,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "product",
      detail: true,
      edit: false,
      editId: "id",
      editType: null,
      add: false,
      addType: "text",
      addMessage: "",
    },
    {
      key: "product_id",
      name: "商材名",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: false,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: "product",
      detail: false,
      edit: false,
      editId: "id",
      editType: null,
      add: true,
      addType: "product",
      addMessage: "",
    },
    {
      key: "site_path",
      name: "サイトパス",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: true,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      editType: null,
      detail: true,
      edit: false,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "outside_entry_site_id",
      name: "サイトパス",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: false,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      editType: null,
      detail: false,
      edit: false,
      editId: "",
      add: true,
      addType: "outside_site_path",
      addMessage: "",
    },
    {
      key: "entry_sale_company_id",
      name: "エントリーパートナー",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: false,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: false,
      edit: false,
      editId: "id",
      editType: null,
      add: true,
      addType: "company",
      addMessage: "",
    },
    {
      key: "entry_sale_company_name",
      name: "エントリーパートナー",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: true,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "company",
      detail: true,
      edit: false,
      editId: "id",
      editType: null,
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "entry_sale_company_group",
      name: "グループの指定",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: true,
      tableMinWidth: "100px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: true,
      edit: false,
      editId: "id",
      editType: null,
      add: true,
      addType: "list",
      addMessage: "",
    },
    {
      key: "trial_period_months",
      name: "無料期間",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: true,
      tableMinWidth: "75px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: true,
      edit: true,
      editId: "id",
      editType: "list",
      add: true,
      addType: "list",
      addMessage: "",
    },
    {
      key: "view_service_site",
      name: "サービスサイト導線",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: true,
      tableMinWidth: "130px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: true,
      edit: true,
      editId: "id",
      editType: "list",
      add: true,
      addType: "list",
      addMessage:
        "非表示とした場合、申込後の「サービスサイトはこちら」が表示されなくなります。",
    },
    {
      key: "service_option_name_pull_down",
      name: "外部サービス項目名（プルダウン）",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: false,
      tableMinWidth: "220px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: true,
      edit: true,
      editId: "id",
      editType: "text",
      add: true,
      addType: "text",
      addMessage:
        "※「空欄」とした場合、プルダウンの外部サービスが表示されなくなります。",
    },
    {
      key: "service_required_optional_pull_down",
      name: "サービス（プルダウン）の選択 必須・任意",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: false,
      tableMinWidth: "220px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: true,
      edit: true,
      editId: "id",
      editType: "list",
      add: true,
      addType: "list",
      addMessage: "",
    },
    {
      key: "service_option_name_check_box",
      name: "外部サービス項目名（チェックボックス）",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: false,
      tableMinWidth: "220px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: true,
      edit: true,
      editId: "id",
      editType: "text",
      add: true,
      addType: "text",
      addMessage:
        "※「空欄」とした場合、チェックボックスの外部サービスが表示されなくなります。",
    },
    {
      key: "service_required_optional_check_box",
      name: "サービス（チェックボックス）の選択 必須・任意",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: false,
      tableMinWidth: "220px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: true,
      edit: true,
      editId: "id",
      editType: "list",
      add: true,
      addType: "list",
      addMessage: "",
    },
  ],
  spTier: 'sp_first',
  subTable: [
    {
      subTableAuth: ["マスターアカウント", "スタッフアカウント"],
      subTableColumnName: "グループ一覧",
      subTableColumnLength: "group_length",
      subTableColumnNameWidth: "85px",
      detailKey: ["id"],
      subTableDetail: false,
      subTableDetailTitle: "グループ詳細",
      subTableAdd: true,
      subTableAddTitle: "グループ追加",
      subTableAddTitleWidth: "85px",
      subTableEdit: false,
      subTableEditTitle: "グループ編集",
      subTableEditDirect: false,
      subTableEditDirectKey: "",
      subTableEditAuth: ["マスターアカウント", "スタッフアカウント"],
      tableFunction: [],
      subDataColumn: [
        {
          key: "group_name",
          name: "グループ名",
          table: true,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "id",
          add: true,
          addType: "mgr_group",
          addMessage: "",
        },
      ],
      subTable: [],
    },
    {
      subTableAuth: ["マスターアカウント", "スタッフアカウント"],
      subTableColumnName: "チャットアプリ連携一覧",
      subTableColumnLength: "chat_app_length",
      detailKey: ["id"],
      subTableColumnNameWidth: "170px",
      subTableDetail: true,
      subTableDetailTitle: "チャットアプリ連携詳細",
      subTableAdd: true,
      subTableAddTitle: "チャットアプリ連携追加",
      subTableAddTitleWidth: "180px",
      subTableEdit: true,
      subTableEditTitle: "チャットアプリ連携編集",
      subTableEditDirect: false,
      subTableEditDirectKey: "",
      subTableEditAuth: ["マスターアカウント", "スタッフアカウント"],
      tableFunction: [
        {
          name: "削除",
          auth: ["マスターアカウント", "スタッフアカウント"],
        },
      ],
      subDataColumn: [
        {
          key: "outside_entry_form_id",
          name: "外部ETフォームID",
          table: false,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "id",
          add: true,
          addType: "tableId",
          addMessage: "",
        },
        {
          key: "sns_type",
          name: "チャットアプリ連携タイプ",
          table: true,
          tableValue: "text",
          detail: true,
          edit: true,
          editType: "list",
          editId: "id",
          add: true,
          addType: "list",
          addMessage: "",
        },
        {
          key: "sns_id",
          name: "連携ID",
          table: true,
          tableValue: "text",
          detail: true,
          edit: true,
          editType: "text",
          editId: "id",
          add: true,
          addType: "text",
          addMessage: "",
        },
        {
          key: "sns_haeder",
          name: "チャットアプリ連携時ヘッダー",
          table: false,
          tableValue: "text",
          detail: true,
          edit: true,
          editType: "multitext",
          editId: "id",
          add: true,
          addType: "multitext",
          addMessage:
            "※末尾に自動的に改行が入ります。指定しない場合は空欄としてください。",
        },
        {
          key: "sns_footer",
          name: "チャットアプリ連携時フッター",
          table: false,
          tableValue: "text",
          detail: true,
          edit: true,
          editType: "multitext",
          editId: "id",
          add: true,
          addType: "multitext",
          addMessage:
            "※先頭に自動的に改行が入ります。指定しない場合は空欄としてください。",
        },
      ],
      subTable: [
        {
          subTableAuth: ["マスターアカウント", "スタッフアカウント"],
          subTableColumnName: "チャット連携-依存質問-選択肢一覧",
          subTableColumnLength: "chat_app_depend_select_length",
          detailKey: ["id"],
          subTableColumnNameWidth: "130px",
          subTableDetail: false,
          subTableDetailTitle: "依存質問-選択肢詳細",
          subTableAdd: true,
          subTableAddTitle: "依存質問-選択肢追加",
          subTableAddTitleWidth: "130px",
          subTableEdit: false,
          subTableEditTitle: "依存質問-選択肢編集",
          subTableEditDirect: false,
          subTableEditDirectKey: "",
          subTableEditAuth: ["マスターアカウント", "スタッフアカウント"],
          tableFunction: [
            {
              name: "削除",
              auth: ["マスターアカウント", "スタッフアカウント"],
            },
          ],
          subDataColumn: [
            {
              key: "depend_option_name",
              name: "依存質問名",
              table: true,
              tableValue: "text",
              detail: false,
              edit: false,
              editType: null,
              editId: "id",
              add: false,
              addType: "text",
              addMessage: "",
            },
            {
              key: "depend_option_select",
              name: "選択肢",
              table: true,
              tableValue: "text",
              detail: false,
              edit: false,
              editType: null,
              editId: "id",
              add: false,
              addType: "text",
              addMessage: "",
            },
          ],
          subTable: [],
        },
      ],
    },
    {
      subTableAuth: ["マスターアカウント", "スタッフアカウント"],
      subTableColumnName: "外部用サービス一覧",
      subTableColumnLength: "service_length",
      subTableColumnNameWidth: "130px",
      detailKey: ["id"],
      subTableDetail: true,
      subTableDetailTitle: "外部用サービス詳細",
      subTableAdd: true,
      subTableAddTitle: "外部用サービス追加",
      subTableAddTitleWidth: "130px",
      subTableEdit: false,
      subTableEditTitle: "外部用サービス編集",
      subTableEditDirect: false,
      subTableEditDirectKey: "",
      subTableEditAuth: ["マスターアカウント", "スタッフアカウント"],
      tableFunction: [
        {
          name: "削除",
          auth: ["マスターアカウント", "スタッフアカウント"],
        },
      ],
      subDataColumn: [
        {
          key: "outside_entry_form_id",
          name: "外部エントリーフォームID",
          table: false,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "",
          add: true,
          addType: "tableId",
          addMessage: "",
        },
        {
          key: "site_path",
          name: "サイトパス",
          table: false,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "",
          add: true,
          addType: "tableData",
          addMessage: "",
        },
        {
          key: "entry_sale_company_name",
          name: "エントリーパートナー",
          table: false,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "",
          add: true,
          addType: "tableData",
          addMessage: "",
        },
        {
          key: "site_service_name",
          name: "サイト表示名",
          table: true,
          tableValue: "text",
          detail: true,
          edit: true,
          editType: "text",
          editId: "id",
          add: true,
          addType: "text",
          addMessage: "※外部サイトでの表示名となります。 コンマ(,)不可",
        },
        {
          key: "outside_entry_form_service_type",
          name: "表示形式",
          table: true,
          tableValue: "text",
          detail: true,
          edit: true,
          editType: "list",
          editId: "id",
          add: true,
          addType: "list",
          addMessage: "※外部サイトでの表示名となります。",
        },
        {
          key: "site_service_value",
          name: "値段",
          table: true,
          tableValue: "text",
          detail: true,
          edit: true,
          editType: "text",
          editId: "id",
          add: true,
          addType: "text",
          addMessage:
            "※値段と消費税を「0」とした場合は、値段の表示を行いません。",
        },
        {
          key: "site_service_tax",
          name: "消費税",
          table: true,
          tableValue: "text",
          detail: true,
          edit: true,
          editType: "text",
          editId: "id",
          add: true,
          addType: "text",
          addMessage:
            "※値段と消費税を「0」とした場合は、値段の表示を行いません。",
        },
      ],
      subTable: [
        {
          subTableAuth: ["マスターアカウント", "スタッフアカウント"],
          subTableColumnName: "内部サービス紐づけ一覧",
          subTableColumnLength: "inside_service_length",
          subTableColumnNameWidth: "140px",
          detailKey: ["id"],
          subTableDetail: false,
          subTableDetailTitle: "内部サービス紐づけ詳細",
          subTableAdd: true,
          subTableAddTitle: "内部サービス紐づけ追加",
          subTableAddTitleWidth: "140px",
          subTableEdit: false,
          subTableEditTitle: "内部サービス紐づけ編集",
          subTableEditDirect: false,
          subTableEditDirectKey: "",
          subTableEditAuth: ["マスターアカウント", "スタッフアカウント"],
          tableFunction: [],
          subDataColumn: [
            {
              key: "service_name",
              name: "サービス名",
              table: true,
              tableValue: "text",
              detail: false,
              edit: false,
              editType: null,
              editId: "id",
              add: true,
              addType: "follow_call_service",
              addMessage: "",
            },
          ],
          subTable: [],
        },
      ],
    },
    {
      subTableAuth: ["マスターアカウント", "スタッフアカウント"],
      subTableColumnName: "SMS一覧",
      subTableColumnLength: "sms_length",
      subTableColumnNameWidth: "65px",
      detailKey: ["id"],
      subTableDetail: true,
      subTableDetailTitle: "SMS詳細",
      subTableAdd: true,
      subTableAddTitle: "SMS追加",
      subTableAddTitleWidth: "65px",
      subTableEdit: false,
      subTableEditTitle: "SMS編集",
      subTableEditDirect: false,
      subTableEditDirectKey: "",
      subTableEditAuth: ["マスターアカウント", "スタッフアカウント"],
      tableFunction: [
        {
          name: "削除",
          auth: ["マスターアカウント", "スタッフアカウント"],
        },
      ],
      subDataColumn: [
        {
          key: "outside_entry_form_id",
          name: "外部エントリーフォームID",
          table: false,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "",
          add: true,
          addType: "tableId",
          addMessage: "",
        },
        {
          key: "site_path",
          name: "サイトパス",
          table: false,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "",
          add: true,
          addType: "tableData",
          addMessage: "",
        },
        {
          key: "entry_sale_company_name",
          name: "エントリーパートナー",
          table: false,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "",
          add: true,
          addType: "tableData",
          addMessage: "",
        },
        {
          key: "outside_sms_name",
          name: "SMS識別名称",
          table: true,
          tableValue: "text",
          detail: true,
          edit: true,
          editType: "text",
          editId: "id",
          add: true,
          addType: "text",
          addMessage:
            "※内部エントリーフォームのプルダウンで使用する識別名称になります。顧客からは見えません",
        },
        {
          key: "outside_sms_type",
          name: "SMSタイプ",
          table: true,
          tableValue: "text",
          detail: true,
          edit: false,
          editType: null,
          editId: "id",
          add: true,
          addType: "list",
          addMessage: "",
        },
        {
          key: "outside_sms_auth",
          name: "承認状況",
          table: true,
          tableValue: "text",
          detail: true,
          edit: false,
          editType: null,
          editId: "id",
          add: false,
          addType: null,
          addMessage: "",
        },
        {
          key: "outside_sms_sender",
          name: "送信元ID・メールアドレス",
          table: true,
          tableValue: "text",
          detail: true,
          edit: true,
          editType: "text",
          editId: "id",
          add: true,
          addType: "text",
          addMessage:
            "※ショートメッセージの場合「送信元ID」、メールの場合「メールアドレス」を入力してください\n※送信元IDは「大文字英数字11文字まで」指定可能です。　例：SYOZAI",
        },
        {
          key: "outside_sms_title",
          name: "メールタイトル",
          table: true,
          tableValue: "text",
          detail: true,
          edit: true,
          editType: "text",
          editId: "id",
          add: true,
          addType: "text",
          addMessage:
            "※埋め込み可能：{{顧客氏名}}、{{商材名}}、{{サイトタイトル}}\n例：【{{商材名}}】ご登録のご案内",
        },
        {
          key: "outside_sms_body",
          name: "本文",
          table: false,
          tableValue: null,
          detail: true,
          edit: true,
          editType: "multitext",
          editId: "id",
          add: true,
          addType: "multitext",
          addMessage:
            "※埋め込み可能：{{quickpass-URL}}、{{サービスページ-URL}}、{{顧客氏名}}、{{商材名}}、{{サイトタイトル}}\n例：下記URLからご登録をお願いします。\n{{quickpass-URL}}\n登録サイトよりお問い合わせください。",
        },
      ],
      subTable: [],
    },
    {
      subTableAuth: ["マスターアカウント", "スタッフアカウント"],
      subTableColumnName: "解約SMS一覧",
      subTableColumnLength: "cancell_sms_length",
      detailKey: ["id"],
      subTableColumnNameWidth: "90px",
      subTableDetail: true,
      subTableDetailTitle: "解約SMS詳細",
      subTableAdd: true,
      subTableAddTitle: "解約SMS追加",
      subTableAddTitleWidth: "90px",
      subTableEdit: false,
      subTableEditTitle: "解約SMS編集",
      subTableEditDirect: false,
      subTableEditDirectKey: "",
      subTableEditAuth: ["マスターアカウント", "スタッフアカウント"],
      tableFunction: [
        {
          name: "削除",
          auth: ["マスターアカウント", "スタッフアカウント"],
        },
      ],
      subDataColumn: [
        {
          key: "outside_entry_form_id",
          name: "外部エントリーフォームID",
          table: false,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "",
          add: true,
          addType: "tableId",
          addMessage: "",
        },
        {
          key: "site_path",
          name: "サイトパス",
          table: false,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "",
          add: true,
          addType: "tableData",
          addMessage: "",
        },
        {
          key: "entry_sale_company_name",
          name: "エントリーパートナー",
          table: false,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "",
          add: true,
          addType: "tableData",
          addMessage: "",
        },
        {
          key: "cancell_sms_name",
          name: "解約SMS識別名称",
          table: true,
          tableValue: "text",
          detail: true,
          edit: true,
          editType: "text",
          editId: "id",
          add: true,
          addType: "text",
          addMessage: "※内部で使用する識別名称です。顧客からは見えません。",
        },
        {
          key: "cancell_sms_type",
          name: "SMSタイプ",
          table: true,
          tableValue: "text",
          detail: true,
          edit: false,
          editType: null,
          editId: "id",
          add: true,
          addType: "list",
          addMessage: "",
        },
        {
          key: "cancell_sms_auth",
          name: "承認状況",
          table: true,
          tableValue: "text",
          detail: true,
          edit: false,
          editType: null,
          editId: "id",
          add: false,
          addType: null,
          addMessage: "",
        },
        {
          key: "cancell_sms_sender",
          name: "送信元ID・メールアドレス",
          table: true,
          tableValue: "text",
          detail: true,
          edit: true,
          editType: "text",
          editId: "id",
          add: true,
          addType: "text",
          addMessage:
            "※ショートメッセージの場合は「送信元ID」、メールの場合は「メールアドレス」を入力してください。",
        },
        {
          key: "cancell_sms_title",
          name: "メールタイトル",
          table: true,
          tableValue: "text",
          detail: true,
          edit: true,
          editType: "text",
          editId: "id",
          add: true,
          addType: "text",
          addMessage:
            "※メールの場合のみ。埋め込み可能：{{顧客氏名}}、{{商材名}}、{{申込番号}}、{{解約日}}",
        },
        {
          key: "cancell_sms_body",
          name: "本文",
          table: false,
          tableValue: null,
          detail: true,
          edit: true,
          editType: "multitext",
          editId: "id",
          add: true,
          addType: "multitext",
          addMessage:
            "※埋め込み可能：{{顧客氏名}}、{{商材名}}、{{申込番号}}、{{解約日}}",
        },
      ],
      subTable: [],
    },
    {
      subTableAuth: ["マスターアカウント", "スタッフアカウント"],
      subTableColumnName: "質問一覧",
      subTableColumnLength: "option_length",
      detailKey: ["id"],
      subTableColumnNameWidth: "85px",
      subTableDetail: false,
      subTableDetailTitle: "質問一覧詳細",
      subTableAdd: true,
      subTableAddTitle: "質問一覧編集・追加",
      subTableAddLabel: "編集・追加",
      subTableAddTitleWidth: "120px",
      subTableEdit: false,
      subTableEditTitle: "質問一覧編集",
      subTableEditDirect: true,
      subTableEditDirectKey: "id",
      subTableEditAuth: ["マスターアカウント", "スタッフアカウント"],
      tableFunction: [],
      subDataColumn: [
        {
          key: "product_id",
          name: "商材名",
          table: false,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "product_id",
          add: false,
          addType: "tableId",
          addMessage: "",
        },
        {
          key: "product_name",
          name: "商材名",
          table: false,
          tableValue: "text",
          detail: true,
          edit: false,
          editType: null,
          editId: "product_id",
          add: false,
          addType: "tableData",
          addMessage: "",
        },
        {
          key: "option_name",
          name: "質問名",
          table: true,
          tableValue: "text",
          detail: true,
          edit: false,
          editType: "text",
          editId: "id",
          add: false,
          addType: "text",
          addMessage: "",
        },
        {
          key: "outside_form_display",
          name: "外部ETフォームでの表示",
          table: true,
          tableValue: "text",
          detail: true,
          edit: false,
          editType: "text",
          editId: "id",
          add: false,
          addType: "text",
          addMessage: "",
        },
        {
          key: "sns_send",
          name: "チャットアプリ連携",
          table: true,
          tableValue: "text",
          detail: true,
          edit: false,
          editType: "text",
          editId: "id",
          add: false,
          addType: "text",
          addMessage: "",
        },
        {
          key: "required_optional",
          name: "必須フラグ",
          table: true,
          tableValue: "text",
          detail: true,
          edit: false,
          editType: "text",
          editId: "id",
          add: false,
          addType: "text",
          addMessage: "",
        },
        {
          key: "option_type",
          name: "質問区分",
          table: true,
          tableValue: "text",
          detail: true,
          edit: false,
          editType: "text",
          editId: "id",
          add: false,
          addType: "text",
          addMessage: "",
        },
        {
          key: "option_default_value",
          name: "デフォルト値",
          table: true,
          tableValue: "text",
          detail: true,
          edit: false,
          editType: "text",
          editId: "id",
          add: false,
          addType: "text",
          addMessage: "",
        },
        {
          key: "change_value_conf",
          name: "入力値の編集",
          table: true,
          tableValue: "text",
          detail: true,
          edit: false,
          editType: "text",
          editId: "id",
          add: false,
          addType: "text",
          addMessage: "",
        },
        {
          key: "option_comment",
          name: "説明",
          table: true,
          tableValue: "text",
          detail: true,
          edit: false,
          editType: "text",
          editId: "id",
          add: false,
          addType: "text",
          addMessage: "",
        },
        {
          key: "option_flg",
          name: "フラグ設定",
          table: true,
          tableValue: "text",
          detail: true,
          edit: false,
          editType: "text",
          editId: "id",
          add: false,
          addType: "text",
          addMessage: "",
        },
        {
          key: "option_select",
          name: "選択肢",
          table: false,
          tableValue: null,
          detail: true,
          edit: false,
          editType: "text",
          editId: "id",
          add: false,
          addType: "text",
          addMessage: "",
        },
      ],
      subTable: [
        {
          subTableAuth: ["マスターアカウント", "スタッフアカウント"],
          subTableColumnName: "選択肢一覧",
          subTableColumnLength: "option_select_length",
          detailKey: ["id"],
          subTableColumnNameWidth: "100px",
          subTableDetail: false,
          subTableDetailTitle: "選択肢詳細",
          subTableAdd: false,
          subTableAddTitle: "選択肢追加",
          subTableAddTitleWidth: "100px",
          subTableEdit: false,
          subTableEditTitle: "選択肢編集",
          subTableEditDirect: false,
          subTableEditDirectKey: "",
          subTableEditAuth: [],
          tableFunction: [],
          subDataColumn: [
            {
              key: "option_select",
              name: "選択肢",
              table: true,
              tableValue: "text",
              detail: false,
              edit: false,
              editType: null,
              editId: "id",
              add: false,
              addType: "text",
              addMessage: "",
            },
          ],
          subTable: [],
        },
        {
          subTableAuth: ["マスターアカウント", "スタッフアカウント"],
          subTableColumnName: "依存外部サービス一覧",
          subTableColumnLength: "option_depend_service_length",
          detailKey: ["id"],
          subTableColumnNameWidth: "100px",
          subTableDetail: false,
          subTableDetailTitle: "依存外部サービス詳細",
          subTableAdd: false,
          subTableAddTitle: "依存外部サービス追加",
          subTableAddTitleWidth: "100px",
          subTableEdit: false,
          subTableEditTitle: "依存外部サービス編集",
          subTableEditDirect: false,
          subTableEditDirectKey: "",
          subTableEditAuth: [],
          tableFunction: [],
          subDataColumn: [
            {
              key: "service_name",
              name: "依存外部サービス名",
              table: true,
              tableValue: "text",
              detail: false,
              edit: false,
              editType: null,
              editId: "id",
              add: false,
              addType: "text",
              addMessage: "",
            },
          ],
          subTable: [],
        },
        {
          subTableAuth: ["マスターアカウント", "スタッフアカウント"],
          subTableColumnName: "依存質問-選択肢一覧",
          subTableColumnLength: "option_depend_select_length",
          detailKey: ["id"],
          subTableColumnNameWidth: "130px",
          subTableDetail: false,
          subTableDetailTitle: "依存質問-選択肢詳細",
          subTableAdd: false,
          subTableAddTitle: "依存質問-選択肢追加",
          subTableAddTitleWidth: "160px",
          subTableEdit: false,
          subTableEditTitle: "依存質問-選択肢編集",
          subTableEditDirect: false,
          subTableEditDirectKey: "",
          subTableEditAuth: [],
          tableFunction: [],
          subDataColumn: [
            {
              key: "depend_option_name",
              name: "依存質問名",
              table: true,
              tableValue: "text",
              detail: false,
              edit: false,
              editType: null,
              editId: "id",
              add: false,
              addType: "text",
              addMessage: "",
            },
            {
              key: "depend_option_select",
              name: "選択肢",
              table: true,
              tableValue: "text",
              detail: false,
              edit: false,
              editType: null,
              editId: "id",
              add: false,
              addType: "text",
              addMessage: "",
            },
          ],
          subTable: [],
        },
      ],
    },
  ],
};
